import {IReport} from "@/modules/Report/interfaces/report.interface";
import {IBook} from "@/interfaces/book.interface";
import {BookStore} from "@/store/modules/book.store";
import {ReportStore} from "@/modules/Report/stores/report.store";
import moment from "moment";
import {IApp} from "@/interfaces/app.interface";

export namespace ReportPrintActions {
  export interface IPrintOptions {
    $options: any;
    tableList: IReport.ReportType;
    dataProps: IReport.ITableProp[];
  }

  const LabelReports = {
    [IReport.ReportName.Movement]: 'Движения',
    [IReport.ReportName.Events]: 'События',
    [IReport.ReportName.Balance]: 'Баланс',
    [IReport.ReportName.Cars]: 'Сводная по машинам',
    [IReport.ReportName.Parks]: 'Сводная по парковке',
    [IReport.ReportName.CarsBalance]: 'Баланс по машинам',
    [IReport.ReportName.Agent]: 'Отчет агента',
  };

  const prepareTable = (options: IPrintOptions) => {
    const propType = IApp.SortingPropType;

    let headRow = '<tr>';
    options.dataProps.forEach((cell: IReport.ITableProp) => {
      if (!cell.noPrint) headRow += `<td colspan="${cell.colspan ? cell.colspan : 1}"><b>${cell.label}</b></td>`
    });
    headRow += '</tr>';

    let bodyRows = '';
    options.tableList.forEach(row => {
      bodyRows += '<tr>';
      options.dataProps.forEach(cell => {
        let value = '';
        if (cell.propType === propType.Number && row[cell.prop]) {
          value = options.$options.filters.currency(row[cell.prop], cell.isMoney ? '₽' : '');
        }
        else if (cell.propType === propType.Date && row[cell.prop]) {
          value = moment(row[cell.prop]).format(cell.dateFormat);
        }
        else {
          value = row[cell.prop] ? row[cell.prop] : '';
        }
        if (cell.usePrintedValue) {
          value = row[`${cell.prop}Printed`];
        }

        if (!cell.noPrint) bodyRows += `<td colspan="${cell.colspan ? cell.colspan : 1}">${value}</td>`
      });
      bodyRows += '</tr>';
    });

    let table = `
      <table border="1">
        ${headRow}
        ${bodyRows}
      `;
    table += '</table>';

    return table;
  };

  export const PrintTable = (options: IPrintOptions) => {
    if (!options.tableList.length) return;

    const corps = BookStore.state.books[IBook.BookName.Corps];

    let mywindow = window.open('', 'PRINT', 'height=400,width=600');
    mywindow.document.write('<html><head></head><body >');

    const filters = ReportStore.state.filters;
    let filterRow = ``;
    if (filters.str) filterRow += `<br>Поиск: ${filters.str}`;
    if (filters.corpId) filterRow += `<br>Корпорация: ${filters.corpName}`;
    if ((filters.dateBeg || filters.dateEnd) && (filters.dateBeg !== 'Invalid date' || filters.dateEnd !== 'Invalid date' )) {
      filterRow += `<br>Период: ${filters.dateBeg ? 'от ' + options.$options.filters.moment(filters.dateBeg, 'DD.MM.YYYY') : ''} ${filters.dateEnd ? 'до ' + options.$options.filters.moment(filters.dateEnd, 'DD.MM.YYYY') : ''}`;
    }

    let table = `
      <h1>${LabelReports[ReportStore.state.activeReport]}</h1>
      <p>${filterRow ? (filterRow) : ''}</p>
      ${prepareTable(options)}
    `;
    mywindow.document.write(table);

    mywindow.document.write('</body></html>');
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
  };

  export const PrepareExcel = (options: IPrintOptions) => {
    const table = prepareTable(options);
    return {
      table,
      tableName: LabelReports[ReportStore.state.activeReport],
      fileName: `${LabelReports[ReportStore.state.activeReport]}.xls`
    };
  }
}
